import {createAction} from 'redux-act';

export const setDefaultLocationConfigShown = createAction<boolean>('ui/defaultLocationConfigShown');
